import DatabaseService from './DatabaseService.js'
import UserService from './DatabaseService.js'
import {setLeaderboards} from 'actions/leaderboards.js'


class ChallengeService {

    getUserChallengeByCategoryId(categoryId)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchUserChallengeByCategoryId(categoryId).then(
				function(result){ 
                    console.log("getUserChallengeByCategoryId", result)
                    resolve(result) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    
    // Gets all of today's UserChallenges for current user
    getUserChallenges()
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchUserChallenges(UserService.getCurrentUser().id).then(
				function(result){ resolve(result) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    

    // Gets all of today's UserChallenges for current user
    getUserChallengeJSON(userChallengeId)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchUserChallenge(userChallengeId).then(
				function(result){ resolve(result) },
				function(error){
                    console.error(error);
                    reject(error); 
                });
		});
    }
    
    // Completes a challenge by userChallengeId. If the challenge is multi-step this will only increment the step by 1.
    completeChallenge(userChallengeId, increment, photo)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.completeChallenge(userChallengeId, increment, photo).then(
				function(result){ resolve(result) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    
    //////////////////////
    // Timeline Functions
    //////////////////////
    
    
    //////////////////////
    // Category Functions
    //////////////////////
    
    getCategories()
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchCategories().then(
				function(results){ 
                    resolve(results) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getLocalizedCategories(locale)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchLocalizedCategories(locale).then(
				function(results){ resolve(results) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getUserCategories(includeCategory)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchUserCategories(includeCategory).then(
				function(results){ resolve(results) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getCategoryList(locale)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchCategoryList(locale).then(
				function(results){ 
                    resolve(results) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getUserCategoriesHash(include)
    {
		return new Promise(function(resolve, reject) {
			this.getUserCategories(true).then(
				function(categories){ 
                    var hash = [];
                    for(var i = 0; i < categories.length; i++)
                    {
                        hash[categories[i].category.id] = categories[i]
                    }
                    resolve(hash) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    updateUserCategoryTimes(userCategories)
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.updateUserCategoryTimes(userCategories).then(
				function(results){ resolve(results) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    // Completes a challenge by userChallengeId. If the challenge is multi-step this will only increment the step by 1.
    getCategoryNotifications()
    {
        return new Promise(function(resolve, reject) {
            DatabaseService.fetchCategoryNotifications().then(
                function(results){ 
                    resolve(results) 
                },
                function(error){ 
                    console.error(error);
                    reject(error); 
                });
        }); 
    }
    getRandomCategoryNotification(categoryId)
    {
		return new Promise(function(resolve, reject) {
			this.getCategoryNotifications().then(function(notifications) { 
                    for(var i = 0; i < notifications.length; i++)
                    {
                        if(notifications[i].category.id === categoryId)
                        {
                            resolve(notifications[i].notifications[Math.floor(notifications[i].notifications.length*Math.random())])
                            return;
                        }
                    }
                    reject("No notifications for category");
                });
        });
    }
    
    ////////////////////////////
    // Leaderboard Cloud Functions
    ////////////////////////////
    
    getLeaderboards()
    {
		return new Promise(function(resolve, reject) {
			DatabaseService.fetchLeaderboards().then(
				function(result){ 
                    resolve(result) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    getLeaderboard(id)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboard({leaderboardId:id}).then(
				function(result){ resolve(result) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getRecords(params)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchRecords(params).then(
				function(results){ resolve(results) },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    getLeaderboardUserRank(inTeam)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboardUserRank(inTeam).then(
				function(results){ 
                    resolve(results) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getLeaderboardEveryone()
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboardEveryone().then(
				function(results){ 
                    resolve(results) 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getLeaderboardCategory(categoryId)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboardCategory(categoryId).then(
				function(results){ 
                    resolve(results); 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getLeaderboardTeams()
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboardTeams().then(
				function(results){ 
                    resolve(results); 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getLeaderboardTeam(leaderboardId, teamId)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchLeaderboardTeam({leaderboardId:leaderboardId,teamId:teamId}).then(
				function(results){ 
                    resolve(results); 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    
    // Profile
    
    getUserCategoryStats()
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchUserCategoryStats().then(
				function(results){ 
                    resolve(results); 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    getActiveCategoryCounts()
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchActiveCategoryCounts().then(
				function(results){ 
                    resolve(results); 
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    // Rewards
    getRewards()
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchRewards().then(
				function(results){ 
                    resolve(results);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    redeemReward(rewardId)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.redeemReward(rewardId).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }

    // News Feed

    getCompanyAnnouncementsFeed(date, limit) {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchCompanyAnnouncementsFeed(date, limit).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getActivityFeed(date, limit, userProfile)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchActivityFeed(date, limit, userProfile).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    getMyProgressFeed(date, limit, userProfile)
    {
		return new Promise(function(resolve, reject) {
            DatabaseService.fetchMyProgressFeed(date, limit, userProfile).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
		});
    }
    
    addActivityReaction(feedActionId,reactionId)
    {
        return new Promise(function(resolve,reject){
            DatabaseService.addActivityReaction(feedActionId,reactionId).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
        })
    }

    removeActivityReaction(feedActionId, reactionId)
    {
        return new Promise(function(resolve,reject){
            DatabaseService.removeActivityReaction(feedActionId, reactionId).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
        })
    }
    reportActivityReaction(feedActionId, reportId, comment)
    {
        return new Promise(function(resolve,reject){
            DatabaseService.reportActivityReaction(feedActionId, reportId, comment).then(
				function(result){ 
                    resolve(result);
                },
				function(error){ 
                    console.error(error);
                    reject(error); 
                });
        })
    }
    
}

export default new ChallengeService();




// WEBPACK FOOTER //
// ./src/services/ChallengeService.js